import React from 'react'
import PropTypes from 'prop-types'
import placeholderImage from 'assets/images/placeholder.png'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, FreeMode } from 'swiper'
import Link from 'components/Link'
import { useOnScreen } from 'data/hooks/useOnScreen'
import Image from 'components/Image'

const CarouselGetInspired = ({
  featuredRegions,
}) => {
  const componentRef = React.useRef()
  const navigationPrevRef = React.useRef(null)
  const navigationNextRef = React.useRef(null)
  const buttonClasses = 'visible !w-40 !h-40 sm:!w-50 sm:!h-50 top-1/2 -mt-20 sm:-mt-25 ' + (featuredRegions.length < 5 ? 'hidden' : '')
  const { initialLoad } = useOnScreen(componentRef)

  return (
    <div ref={componentRef}>
      {
        initialLoad
        && <>
          <div className="relative flex items-center w-full min-w-0 gap-x-10 xl:gap-x-40 max-w-[1480px] lg:px-10 mx-auto">
            <div ref={navigationPrevRef} className={`swiper-button-prev-static ${buttonClasses}`} />
            <Swiper
              className="max-w-[1280px] md:px-20"
              modules={[Navigation, FreeMode]}
              slidesPerView={'auto'}
              navigation={{
                prevEl: navigationPrevRef.current,
                nextEl: navigationNextRef.current,
              }}
              breakpoints={{
                640: {
                  spaceBetween: 33,
                },
              }}
              freeMode={{
                enabled: true,
                sticky: true,
                momentum: true,
                momentumVelocityRatio: 0.25,
              }}
              onSwiper={(swiper) => {
                setTimeout(() => {
                  // Timeout until prevEl & nextEl refs are defined
                  swiper.params.navigation.prevEl = navigationPrevRef.current
                  swiper.params.navigation.nextEl = navigationNextRef.current

                  // Re-initialise navigation
                  swiper.navigation.destroy()
                  swiper.navigation.init()
                  swiper.navigation.update()
                })
              }}
              observer={true}
            >
              {
                (featuredRegions ?? []).map(region => (
                  <SwiperSlide className="max-w-[221px] w-full ml-20 mr-8 sm:mx-0" key={region?.id}>
                    <Link href={`/${region?.country?.slug}/${region?.slug}`} key={region?.id}>
                      <div className="relative h-full">
                        <Image
                          className="object-cover rounded-3"
                          src={region?.main_media?.url ?? placeholderImage}
                          width={221}
                          height={315}
                        />
                      </div>
                      <div className="flex items-start justify-between my-10 text-14 leading-20">
                        <p className="font-normal text-primary">
                          {region?.country?.value}
                        </p>
                      </div>
                      <div>
                        <h3 className="mb-4 font-serif tracking-tight leading-title text-26 text-grey-900">
                          {region?.value}
                        </h3>
                        <p className="leading-20 text-14 text-grey-1100 opacity-40">
                          {region?.property_count} Villas for Rent
                        </p>
                      </div>
                    </Link>
                  </SwiperSlide>
                ))}
            </Swiper>
            <div ref={navigationNextRef} className={`swiper-button-next-static ${buttonClasses}`} />
          </div>

        </>
      }
    </div>
  )
}

CarouselGetInspired.propTypes = {
  featuredRegions: PropTypes.array,
}

export default CarouselGetInspired
